<template>
  <div class="row">
    <div class="col-xl-9">
      <div class="card">
        <div class="card-header card-header-flex align-items-center">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0">
              <strong>{{ $t("sms.boiteEnvoieSms") }}</strong>
            </h5>
          </div>
          <div>
            <a href="javascript: void(0);" class="btn btn-md btn-light mr-2">
              <json-csv
                style="width: 100%"
                :fields="fields"
                :labels="labels"
                :data="csvTable"
                :name="'Boite d\'envoie.csv'"
                ><a-icon
                  class="anticon mt-2"
                  style="color: green"
                  type="file-excel"
                /><span>CSV</span></json-csv
              >
            </a>

            <a-button type="primary" class="btn" @click="imprimer"
              ><a-icon type="printer" />{{ $t("action.imprimer") }}</a-button
            >
          </div>
        </div>

        <div class="card-body">
          <a-table
            @change="tableChanged"
            rowKey="_id"
            :pagination="tablePagination"
            :data-source="data"
            :columns="columns"
            :loading="tableLoading"
          >
            <template slot="date" slot-scope="text">
              {{ moment(text).format("DD/MM/YYYY hh:mm:ss") }}
            </template>
            <div slot="tags" slot-scope="text, record">
              <div class="d-block">
                <span v-for="item in record.tags" :key="item">
                  <a-tag color="blue">
                    {{ item }}
                  </a-tag>
                </span>
              </div>
            </div>
            <div slot="target" slot-scope="text">
              <div class="d-block">
                <span v-for="item in text" :key="item">
                  <a-tag color="blue" v-if="item === 'father'">
                    {{ $t("sms.pere") }}
                  </a-tag>
                  <a-tag color="pink" v-else-if="item === 'mother'">
                    {{ $t("sms.mere") }}
                  </a-tag>
                  <a-tag color="green" v-else-if="item === 'guardian'">
                    {{ $t("sms.guardian") }}
                  </a-tag>
                  <a-tag color="cyan" v-else-if="item === 'teacher'">
                    {{ $t("emploi.teacher") }}
                  </a-tag>
                  <a-tag color="purple" v-else>
                    {{ $t("sms.specifique") }}
                  </a-tag>
                </span>
              </div>
            </div>
            <div
              slot="filterDropdown"
              slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column,
              }"
              style="padding: 8px"
            >
              <a-input
                v-ant-ref="(c) => (searchInput = c)"
                :placeholder="`${$t('personnel.chercher')} ${column.title}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block"
                @change="
                  (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
                "
                @pressEnter="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
                >{{ $t("paiement.chercher") }}</a-button
              >
              <a-button
                size="small"
                style="width: 90px"
                @click="() => handleReset(clearFilters)"
                >{{ $t("action.reinitialiser") }}</a-button
              >
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template
              slot="expandedRowRender"
              slot-scope="record"
              style="margin: 0"
            >
              <label class="font-weight-bold">{{ $t("sms.message") }} :</label>
              <p>{{ record.message }}</p>
              <div v-if="record.customNumbers">
                <label class="font-weight-bold"
                  >{{ $t("sms.numsSpecifiques") }} :</label
                >
                <p>{{ record.customNumbers }}</p>
              </div>
              <label
                class="font-weight-bold"
                v-if="record.parents && record.parents.length > 0"
                >{{ $t("sms.listeParents") }}
                <a-badge :count="record.parents.length" :overflow-count="999" :number-style="{ backgroundColor: '#52c41a' }" style="margin-left: 8px;" />
                :</label
              >

              <div
                v-if="record.parents && record.parents.length > 0"
                style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; max-height: 400px; overflow-y: auto; padding: 8px; margin-top: 8px;"
              >
                <div v-for="item in record.parents" :key="item._id || (item.parent && item.parent._id)" style="display: flex; align-items: center;">
                  <a-avatar
                    size="large"
                    v-if="item.parent && item.parent.photo"
                    :src="getPhotoUrl(item.parent.photo)"
                    style="margin-right: 12px; flex-shrink: 0;"
                  />
                  <a-avatar
                    v-else
                    size="large"
                    style="color: #f56a00; background-color: #fde3cf; margin-right: 12px; flex-shrink: 0;"
                  >
                    {{ getParentAvatarInitial(item) }}
                  </a-avatar>
                  <div style="flex: 1; min-width: 0;">
                    <div style="font-weight: 500; margin-bottom: 4px;">
                      {{ getParentName(item) }}
                    </div>
                    <div style="color: #8c8c8c; font-size: 12px;">
                      {{ getParentPhone(item) }}
                    </div>
                  </div>
                </div>
              </div>

              <label
                class="font-weight-bold mt-3"
                v-if="record.teachers && record.teachers.length > 0"
                >{{ $t("menu.listeEnseignants") }}
                <a-badge :count="record.teachers.length" :overflow-count="999" :number-style="{ backgroundColor: '#52c41a' }" style="margin-left: 8px;" />
                :</label
              >

              <div
                v-if="record.teachers && record.teachers.length > 0"
                style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; max-height: 400px; overflow-y: auto; padding: 8px; margin-top: 8px;"
              >
                <div v-for="item in record.teachers" :key="item._id" v-if="item && item.employee" style="display: flex; align-items: center;">
                  <a-avatar
                    size="large"
                    v-if="item.employee.photo"
                    :src="getPhotoUrl(item.employee.photo)"
                    style="margin-right: 12px; flex-shrink: 0;"
                  />
                  <a-avatar
                    v-else
                    size="large"
                    style="color: #1890ff; background-color: #e6f7ff; margin-right: 12px; flex-shrink: 0;"
                  >
                    {{ getTeacherAvatarInitial(item.employee) }}
                  </a-avatar>
                  <div style="flex: 1; min-width: 0;">
                    <div style="font-weight: 500; margin-bottom: 4px;">
                      {{ getTeacherFullName(item.employee) }}
                    </div>
                    <div style="color: #8c8c8c; font-size: 12px;">
                      {{ item.employee.phone }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template
              slot="customRender"
              slot-scope="text, record, index, column"
            >
              <span v-if="searchText && searchedColumn === column.dataIndex">
                <template
                  v-for="(fragment, i) in text
                    .toString()
                    .split(
                      new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                    )"
                >
                  <mark
                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                    :key="i"
                    class="highlight"
                    >{{ fragment }}</mark
                  >
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>{{ text }}</template>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <div class="col-xl-3">
      <div class="row">
        <div class="card" style="width: 100%">
          <messageChart :data="chartData" />
        </div>
      </div>
      <div class="row">
        <div class="card" style="width: 100%">
          <messageParTagChart :data="chartData" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import "jspdf-autotable";
import { mapState } from "vuex";
import JsonCsv from "vue-json-csv";
import messageChart from "./components/messageChart";
import messageParTagChart from "./components/messageParTagChart";
import { pdfHeader } from "@/utilities/pdfUtils";

var datePicker = "";
/*
data : {
    nomClient,
    enfant,
    date,
    montant
    tags:Array of keysOf(recipeTypes or/and userDefinedRecipes)
}
*/
const moneyQuery = { status: { $ne: "cancelled" } };

export default {
  components: {
    JsonCsv,
    messageChart,
    messageParTagChart,
  },
  async created() {
    await Promise.all([
      this.fetchSMSHistory(),
      this.fetchAllSms(),
    ]);
  },
  computed: {
    tablePagination() {
      const { current, ...rest } = this.pagination;
      return rest;
    },
    /**
     *         arr.push(this.filtredTable[i].user.userName);
        arr.push(this.filtredTable[i].message);
        arr.push(
          moment(this.filtredTable[i].createdAt).format("DD/MM/YYYY hh:mm:ss")
        );
        arr.push(this.filtredTable[i].totalSMSRSent);
     */
    ...mapState(["settings"]),
    csvTable() {
      const source = this.exportData;
      const data = source.map((item) => {
        let returnValue = { ...item };
        returnValue.userName = returnValue.user && returnValue.user.userName ? returnValue.user.userName : "";
        returnValue.message = returnValue.message || "";

        returnValue.createdAt = moment(returnValue.createdAt).format(
          "DD/MM/YYYY hh:mm:ss"
        );

        returnValue.totalSMSRSent = returnValue.totalSMSRSent;

        return returnValue;
      });
      return data;
    },
    columns() {
      const filters = this.tableFilters || {};
      const sorter = this.tableSorter || {};
      return [
        {
          title: this.$t("sms.envoyeParUser"),
          dataIndex: "user.userName",
          key: "userName",
          filteredValue: filters.userName && filters.userName.length ? filters.userName : [],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) => {
            if (record.user && record.user.userName)
              return record.user.userName.toLowerCase().includes(value.toLowerCase());
            return false;
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          //Mots clés
          title: this.$t("sms.groupe"),
          dataIndex: "target",
          key: "target",
          scopedSlots: {
            customRender: "target",
          },
        },
        {
          //Mots clés
          title: this.$t("sms.tags"),
          dataIndex: "tags",
          key: "tags",
          scopedSlots: {
            customRender: "tags",
          },
        },
        {
          title: this.$t("sms.envoiDate"),
          dataIndex: "createdAt",
          key: "createdAt",
          filteredValue: filters.createdAt && filters.createdAt.length ? filters.createdAt : [],
          sortOrder: sorter.columnKey === "createdAt" ? sorter.order : null,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "date",
          },
          onFilter: (value, record) =>
            moment(record.createdAt)
              .format("DD/MM/YYYY hh:mm:ss")
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
          sorter: true,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("sms.nombreSms"),
          dataIndex: "totalSMSRSent",
          key: "total",
          filteredValue: filters.total && filters.total.length ? filters.total : [],
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) => record.totalSMSRSent == value,
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
      ];
    },
  },
  data() {
    return {
      labels: {
        userName: this.$t("sms.nomUtilisateur"),
        message: this.$t("sms.message"),
        createdAt: this.$t("sms.date"),
        totalSMSRSent: this.$t("sms.nombreSmsEnvoye"),
      },
      fields: ["userName", "message", "createdAt", "totalSMSRSent"],
      datePicker,
      data: [],
      rowData: [],
      chartData: [],
      exportData: [],
      columnsExpanded: [
        {
          title: "Destinataire",
          dataIndex: "father",
          key: "parent",
          scopedSlots: {
            customRender: "parent",
          },
        },
        {
          title: "Téléphone",
          dataIndex: "father.phone",
          class: "bg-transparent text-gray-6",
          scopedSlots: {
            customRender: "phone",
          },
        },
      ],
      filtredTable: [],
      tableFilters: {},
      tableSorter: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
      },
    };
  },
  methods: {
    moment,
    getPhotoUrl(photoPath) {
      return this.settings.resourcesUrl.replace('FILE_PATH', photoPath);
    },
    getParentAvatarInitial(item) {
      const parent = item.parent;
      if (!parent) return '';
      if (item.father && parent.father) {
        return parent.father.firstName?.[0]?.toUpperCase() || '';
      } else if (item.mother && parent.mother) {
        return parent.mother.firstName?.[0]?.toUpperCase() || '';
      } else if (item.guardian && parent.guardian) {
        return parent.guardian.firstName?.[0]?.toUpperCase() || '';
      }
      return '';
    },
    formatFirstMiddleLast(p) {
      if (!p) return "";
      const parts = [p.firstName, p.middleName, p.lastName]
        .map((x) => (x != null && String(x).trim() ? String(x).trim() : ""))
        .filter(Boolean);
      return parts.join(" ");
    },
    getParentName(item) {
      const parent = item.parent;
      if (!parent) return '';
      const parts = [];
      if (item.father && parent.father) {
        parts.push(this.formatFirstMiddleLast(parent.father));
      }
      if (item.mother && parent.mother) {
        parts.push(this.formatFirstMiddleLast(parent.mother));
      }
      if (item.guardian && parent.guardian) {
        parts.push(this.formatFirstMiddleLast(parent.guardian));
      }
      return parts.join(` ${this.$t('all.and')} `);
    },
    getParentPhone(item) {
      const parent = item.parent;
      if (!parent) return '';
      const parts = [];
      if (item.father && parent.father?.phone) parts.push(parent.father.phone);
      if (item.mother && parent.mother?.phone) parts.push(parent.mother.phone);
      if (item.guardian && parent.guardian?.phone) parts.push(parent.guardian.phone);
      return parts.join(' -- ');
    },
    getTeacherAvatarInitial(employee) {
      return employee?.firstName?.[0]?.toUpperCase() || 'T';
    },
    getTeacherFullName(employee) {
      return this.formatFirstMiddleLast(employee || {});
    },
    async fetchSMSHistory(page = 1) {
      this.tableLoading = true;
      try {
        const params = { page };
        const searchColumnMap = { userName: "userName", createdAt: "createdAt", total: "totalSMSRSent" };
        const filterKeys = Object.keys(this.tableFilters || {}).filter(
          (k) => this.tableFilters[k] && this.tableFilters[k].length > 0
        );
        if (filterKeys.length > 0) {
          const col = filterKeys[0];
          params.search = this.tableFilters[col][0];
          params.searchColumn = searchColumnMap[col] || col;
        }
        if (this.tableSorter && this.tableSorter.columnKey != null) {
          const sortFieldMap = { userName: "userName", createdAt: "createdAt" };
          params.sortField = sortFieldMap[this.tableSorter.columnKey] || "createdAt";
          params.sortOrder = this.tableSorter.order === "ascend" ? "ascend" : "descend";
        }
        const res = await apiClient.get("/sms", { params });
        this.data = res.data.data;
        this.rowData = this.data;
        this.filtredTable = [...this.data];
        this.pagination = {
          ...this.pagination,
          current: res.data.page,
          pageSize: res.data.pageSize,
          total: res.data.total,
        };
      } catch (e) {
        this.$message.warning(this.$t("warning.connectionProblem"));
      } finally {
        this.tableLoading = false;
      }
    },
    async fetchAllSms() {
      try {
        const res = await apiClient.get("/sms/all");
        const list = Array.isArray(res.data) ? res.data : [];
        this.chartData = list;
        this.exportData = list;
      } catch (e) {
        this.chartData = [];
        this.exportData = [];
      }
    },
    tableChanged(pagination, filters, sorter) {
      const filtersChanged =
        JSON.stringify(filters || {}) !== JSON.stringify(this.tableFilters || {});
      const sorterChanged =
        sorter &&
        sorter.columnKey != null &&
        ((this.tableSorter && this.tableSorter.columnKey) !== sorter.columnKey ||
          (this.tableSorter && this.tableSorter.order) !== sorter.order);

      this.tableFilters = filters || {};
      if (sorter && sorter.columnKey != null) {
        this.tableSorter = sorter;
      }

      if (filtersChanged || sorterChanged) {
        this.fetchSMSHistory(1);
      } else if (pagination && pagination.current !== undefined) {
        const requestedPage = pagination.current;
        const pageSize = pagination.pageSize !== undefined ? pagination.pageSize : this.pagination.pageSize;
        // Update pagination immediately so the table shows the clicked page on first click
        this.pagination = {
          ...this.pagination,
          current: requestedPage,
          pageSize,
          total: pagination.total !== undefined ? pagination.total : this.pagination.total,
        };
        this.fetchSMSHistory(requestedPage);
      }
    },

    imprimer() {
      this.$gtag.event("Imp SMS Historique", {
        event_category: "Impression PDF",
        event_label: "sms:Historique section",
        value: 1,
      });

      const isArabic = this.$i18n.locale === 'ar-AR';

      const tableSource = this.exportData;

      // Helper function to reverse array if Arabic
      const reverseIfArabic = (arr) => isArabic ? arr.slice().reverse() : arr;

      // Use pdfHeader utility function
      const doc = pdfHeader(this.settings, {
        title: this.$t("sms.boiteEnvoie"),
        locale: this.$i18n.locale
      });
      var arr = [];
      const array = [];
      let totalSMS = 0;
      for (let i = 0; i < tableSource.length; i++) {
        const row = tableSource[i];
        arr.push(row.user && row.user.userName ? row.user.userName : "");
        arr.push(row.message || "");
        arr.push(
          moment(row.createdAt).format("DD/MM/YYYY hh:mm:ss")
        );
        arr.push(row.totalSMSRSent);
        totalSMS += row.totalSMSRSent || 0;

        // Reverse for Arabic if needed
        if (isArabic) {
          arr.reverse();
        }

        array.push(arr);
        arr = [];
      }
      doc.autoTable({
        styles: {
          font: "Amiri",
          halign: isArabic ? "right" : "left",
        },
        headStyles: { halign: isArabic ? "right" : "left" },
        bodyStyles: { halign: isArabic ? "right" : "left" },
        startY: 45,
        head: [
          reverseIfArabic([
            this.$t("sms.nomUtilisateur"),
            this.$t("sms.message"),
            this.$t("sms.date"),
            this.$t("sms.nombreSmsEnvoye"),
          ])
        ],
        body: array,
        foot: [
          reverseIfArabic([
            {
              colSpan: 3,
              content: this.$t("liste.total"),
              styles: { halign: "center" },
            },
            totalSMS,
          ])
        ],
      });
      //page numbering
      const pages = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(8); //Optional

      for (let j = 1; j < pages + 1; j++) {
        let horizontalPos = pageWidth / 2;
        let verticalPos = pageHeight - 10;
        doc.setPage(j);
        doc.text(
          `${this.$t("pdf.pageNumber", { current: j, total: pages })}`,
          horizontalPos,
          verticalPos,
          {
            align: "center",
          }
        );
      }
      //end page numbering
      doc.save(this.$t("menu.etatRecettes") + ".pdf");
    },

    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
  },
};
</script>
